var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('create-new-folder', {
    attrs: {
      "data-to-show": _vm.isCreateFolderPopupDisplayed,
      "parent-folder": _vm.path[_vm.path.length - 1].id,
      "errors": _vm.errorsCreateNewFolder
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupAddNewFolder(val);
      },
      "createNewFolder": function (folder) {
        _vm.createFolder(folder);
      }
    }
  }), _vm._v(" "), _c('edit-folder', {
    attrs: {
      "data-to-show": _vm.isEditFolderPopupDisplayed,
      "errors": _vm.errorsEditFolder,
      "folder": _vm.folderToEdit
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupEditFolder(val);
      },
      "editFolder": function (folderEdited) {
        _vm.editFolder(folderEdited);
      }
    }
  }), _vm._v(" "), _c('delete-folder', {
    attrs: {
      "data-to-show": _vm.isDeleteFolderPopupDisplayed,
      "errors": _vm.errorsDeleteFolder,
      "folder": _vm.folderToDelete
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupDeleteFolder(false);
      },
      "deleteFolder": function ($event) {
        return _vm.deleteFolder();
      }
    }
  }), _vm._v(" "), _c('move-folder', {
    attrs: {
      "data-to-show": _vm.isMoveFilePopupDisplayed,
      "file-to-move": _vm.fileToMove,
      "errors": _vm.errorsMoveFile
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupMoveFile(val);
      },
      "moveFile": function (file) {
        _vm.moveFile(file);
      }
    }
  }), _vm._v(" "), _c('add-member', {
    attrs: {
      "data-to-show": _vm.isAddMemberPopupDisplayed,
      "errors": _vm.errorsAddMemberFolder,
      "folder": _vm.folderToShare
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupAddMember(val);
      },
      "addMembers": function (members) {
        _vm.addMembers(members);
      },
      "editUserRights": function (user, newRights) {
        _vm.editUserRights(user, newRights);
      },
      "editRoleRights": function (role, newRights) {
        _vm.editRoleRights(role, newRights);
      },
      "revokeUserRights": function (user) {
        _vm.revokeUserRights(user);
      },
      "revokeRoleRights": function (role) {
        _vm.revokeRoleRights(role);
      }
    }
  }), _vm._v(" "), _c('add-new-file', {
    attrs: {
      "data-to-show": _vm.stateAddFilePopup,
      "loading": _vm.addNewFileLoading,
      "file-temp": _vm.fileTemp,
      "current-folder": _vm.path[_vm.path.length - 1].id,
      "errors": _vm.errorsAddNewFile
    },
    on: {
      "showChange": function (val) {
        _vm.changeStatePopupAddNewFile(val);
      },
      "addTempFile": function (data) {
        _vm.addTempFile(data);
      },
      "addFile": function (infos) {
        _vm.addFile(infos);
      }
    }
  }), _vm._v(" "), _c('edit-file', {
    attrs: {
      "data-to-show": _vm.isEditFilePopupDisplayed,
      "errors": _vm.errorsEditFile,
      "file": _vm.fileToEdit
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupEditFile(val);
      },
      "editFile": function (fileEdited) {
        _vm.editFile(fileEdited);
      }
    }
  }), _vm._v(" "), _c('preview-file', {
    attrs: {
      "data-to-show": _vm.isPreviewPopupDisplayed,
      "file": _vm.fileToDisplay
    },
    on: {
      "close": function ($event) {
        return _vm.displayPopupPreview(false);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-12"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('h4', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "text-indigo-600 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.goToPath();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.path.length == 1 && Object.keys(_vm.path[0]).length == 0 ? 'Tous les dossiers' : 'Dossiers') + "\n        ")]), _vm._v(" "), _vm._l(_vm.path.filter(function (p) {
    return Object.keys(p).length > 0;
  }), function (p, i) {
    return _c('span', {
      key: i,
      staticClass: "text-gray-600 cursor-pointer",
      on: {
        "click": function ($event) {
          return _vm.goToPath(i);
        }
      }
    }, [_vm._v("\n          > " + _vm._s(p.name))]);
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "relative w-max"
  }, [_c('div', {
    staticClass: "my-10"
  }, [(Object.keys(_vm.path[_vm.path.length - 1]).length == 0 || _vm.$editFile(_vm.path[_vm.path.length - 1], _vm.currentPage)) && _vm.canEdit && _vm.$can(_vm.constants.PERMISSION_DEPOT_DOCUMENTS_CREATE) ? _c('add-button', {
    attrs: {
      "libelle": "Ajouter un nouveau dossier ou fichier",
      "with-dropdown": true
    },
    on: {
      "add": _vm.displayDropdownAddNewFolderOrFile
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.isDropdownCreateFolderOrFileDisplay ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayDropdownAddNewFolderOrFile,
      expression: "displayDropdownAddNewFolderOrFile"
    }],
    staticClass: "absolute z-10 right-0 top-8 px-5 py-3 bg-white shadow rounded-xl text-sm"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5 text-gray-600"
  }, [_c('p', {
    staticClass: "hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.displayPopupAddNewFolder(true);
      }
    }
  }, [_vm._v("\n            Nouveau dossier\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "hover:text-gray-900 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.changeStatePopupAddNewFile(1);
      }
    }
  }, [_vm._v("\n            Nouveau fichier\n          ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: 'grid grid-cols-3 gap-12 ' + (_vm.currentFolders.length > 0 ? 'mb-12' : '')
  }, _vm._l(_vm.currentFolders, function (folder, numFolder) {
    return _c('div', {
      key: numFolder,
      staticClass: "col-span-full md:col-span-1"
    }, [_c('folder-card', {
      attrs: {
        "editable": _vm.$editFile(folder, _vm.currentPage) && _vm.canEdit,
        "is-admin": _vm.$adminFile(folder, _vm.currentPage),
        "is-owner": _vm.$ownerFile(folder, _vm.currentPage),
        "in-neopass-form": _vm.currentPage.includes('/form/neopass/'),
        "folder": folder,
        "folders": _vm.folders,
        "files": _vm.files,
        "smaller": _vm.currentPage.includes('/form/neopass/')
      },
      on: {
        "openFolder": function ($event) {
          return _vm.openFolder(folder);
        },
        "editFolder": function ($event) {
          return _vm.displayPopupEditFolder(true, folder);
        },
        "downloadFolder": function ($event) {
          return _vm.downloadAFolder(folder);
        },
        "deleteFolder": function ($event) {
          return _vm.displayPopupDeleteFolder(true, folder);
        },
        "moveFolder": function ($event) {
          return _vm.displayPopupMoveFile(true, folder);
        },
        "addMember": function ($event) {
          return _vm.displayPopupAddMember(true, folder);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-12"
  }, _vm._l(_vm.currentFiles, function (file, numFile) {
    return _c('div', {
      key: numFile,
      staticClass: "col-span-full md:col-span-1"
    }, [_c('file-card', {
      attrs: {
        "file": file,
        "editable": _vm.$editFile(file, _vm.currentPage) && _vm.canEdit,
        "is-admin": _vm.$adminFile(file, _vm.currentPage),
        "is-owner": _vm.$ownerFile(file, _vm.currentPage),
        "in-neopass-form": _vm.currentPage.includes('/form/neopass/')
      },
      on: {
        "openFile": function ($event) {
          return _vm.displayPopupPreview(true, file);
        },
        "downloadFile": function ($event) {
          return _vm.downloadAFile(file);
        },
        "moveFile": function ($event) {
          return _vm.displayPopupMoveFile(true, file);
        },
        "addMember": function ($event) {
          return _vm.displayPopupAddMember(true, file);
        },
        "editFile": function ($event) {
          return _vm.displayPopupEditFile(true, file);
        },
        "deleteFile": function ($event) {
          return _vm.displayPopupDeleteFolder(true, file);
        }
      }
    })], 1);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }